import { render, staticRenderFns } from "./UsefulTips.vue?vue&type=template&id=1b774e7f"
import script from "./UsefulTips.vue?vue&type=script&lang=js"
export * from "./UsefulTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports